import React from "react";
import "./InputComponent.scss"

const TextAreaComponent = ({ label, value, onChange, placeholder, required, error, errorText, disable, type }) => {


    return (
        <div className="InputComponent-Suvai">
            {label && <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}

            </div>}
            <div className={`InputComponent-Suvai-container ${error ? "error" : disable ? "disable" : ""}`}>
                <textarea
                    className="InputComponent-Suvai-container-textareanew"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default TextAreaComponent